export const SET_WEB_ACCOUNT_FILTERS_DATA = 'SET_WEB_ACCOUNT_FILTERS_DATA';
export const setWebAccountFiltersConfigData = (filterData: any) => ({
  type: SET_WEB_ACCOUNT_FILTERS_DATA,
  payload: filterData,
});

const initialState: any = [];

interface Action {
  type: string;
  payload: any;
}

const webAccountFiltersDataReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_WEB_ACCOUNT_FILTERS_DATA:
      return [...action.payload];
    default:
      return state;
  }
};
export default webAccountFiltersDataReducer;
